import { UserRole } from '@klubovna/api-client';
import { createAction, props } from '@ngrx/store';
import { User } from './users.state';

export interface UsersQueryParams {
  page?: number;
  limit?: number;
  search?: string;
  sortBy?: 'name' | 'email' | 'role' | 'createdAt';
  sortOrder?: 'ASC' | 'DESC';
}

export const loadUsers = createAction(
  '[Users] Load Users',
  props<{ params?: UsersQueryParams }>(),
);

export const loadUsersSuccess = createAction(
  '[Users] Load Users Success',
  props<{ users: User[]; pagination: { total: number; page: number; limit: number; totalPages: number } }>(),
);

export const loadUsersFailure = createAction(
  '[Users] Load Users Failure',
  props<{ error: string }>(),
);

export const createUser = createAction(
  '[Users] Create User',
  props<{ userData: CreateUserData }>(),
);

export const createUserSuccess = createAction(
  '[Users] Create User Success',
  props<{ user: User }>(),
);

export const createUserFailure = createAction(
  '[Users] Create User Failure',
  props<{ error: string }>(),
);

export const updateUser = createAction(
  '[Users] Update User',
  props<{ id: string; userData: UpdateUserData }>(),
);

export const updateUserSuccess = createAction(
  '[Users] Update User Success',
  props<{ user: User }>(),
);

export const updateUserFailure = createAction(
  '[Users] Update User Failure',
  props<{ error: string }>(),
);

export const deleteUser = createAction(
  '[Users] Delete User',
  props<{ id: string }>(),
);

export const deleteUserSuccess = createAction(
  '[Users] Delete User Success',
  props<{ id: string }>(),
);

export const deleteUserFailure = createAction(
  '[Users] Delete User Failure',
  props<{ error: string }>(),
);

export const selectUser = createAction(
  '[Users] Select User',
  props<{ user: User | null }>(),
);

export interface CreateUserData {
  firstName: string;
  lastName: string;
  email: string;
  role: UserRole;
  phoneNumber?: string;
  bio?: string;
}

export interface UpdateUserData {
  firstName?: string;
  lastName?: string;
  email?: string;
  role?: UserRole;
  phoneNumber?: string;
  bio?: string;
  isActive?: boolean;
}
